export const API_ENDPOINTS = {
  USERS: '/users',
  CUSTOMERS: '/customers',
  LOGIN: '/users/login',
  REGISTER: '/users/register',
  LOGOUT: '/users/logout',
  FORGET_PASSWORD: '/forget-password',
  CATEGORIES: '/categories',
  DIETARY: '/dietary.json',
  BRANDS: '/brands.json',
  PRODUCTS: '/products',
  PRODUCTS_IMAGES: '/products-images',
  SEARCH: '/products',
  ORDERS: '/orders',
  PAYMENT: '/payment.json',
  SHOP: '/shop.json',
  SHOPS: '/shops.json',
  WISHLIST: '/wishlist',
  CATEGORIES_FILTER: '/filters/categories',
  KOSHER_FILTER: '/filters/kosher',
  MANUFACTURERS_FILTER: '/filters/manufacturers',
  KOSHER_PESACH_FILTER: '/filters/kosher-pesach',
};
